import React from "react";
import "./App.css";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import Home from "./pages/HomePage";
import AboutUsPage from "./pages/AboutUs";
import ProductsPage from "./pages/ProductsPage";
import AppLayout from "./pages/AppLayout";

const router = createBrowserRouter([
  {
    path: "/",
    element: <AppLayout />,
    children: [
      {
        path: "",
        element: <Home />,
      },
      {
        path: "about-us",
        element: <AboutUsPage />,
      },
    ],
  },
  {
    path: "products",
    element: <ProductsPage />,
  },
]);
function App() {
  return (
    <div id="app">
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
